import { useState } from "react";

export default function ProductApp() {
  const [formData, setFormData] = useState({
    name: "",
    description: "",
    price: "",
    category: "",
    quantity: "",
    image: null,
    origin: "HighnFly",
  });

  const [preview, setPreview] = useState(null);
  const [dragActive, setDragActive] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleFile = (file) => {
    if (!file) return;

    setFormData((prev) => ({
      ...prev,
      image: file,
    }));

    setPreview(URL.createObjectURL(file));
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setDragActive(false);

    const file = e.dataTransfer.files[0];
    handleFile(file);
  };

  const handleDrag = (e) => {
    e.preventDefault();
    e.stopPropagation();

    if (e.type === "dragenter" || e.type === "dragover") {
      setDragActive(true);
    } else {
      setDragActive(false);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const data = new FormData();
    data.append("name", formData.name);
    data.append("description", formData.description);
    data.append("price", formData.price);
    data.append("category", formData.category);
    data.append("quantity", formData.quantity);
    data.append("image", formData.image);
    data.append("origin", formData.origin);

    fetch("https://high-and-fly-1.onrender.com/api/contact/product/", {
      method: "POST",
      body: data,
    })
      .then((res) => {
        if (!res.ok) throw new Error("Upload failed");
        return res.json();
      })
      .then(() => {
        alert("Product created!");
      })
      .catch((err) => {
        console.error(err);
        alert("Error creating product");
      });
  };

  return (
    <div style={{ maxWidth: "600px", margin: "0 auto" }}>
      <h2>Add Product</h2>

      <form onSubmit={handleSubmit}>
        <input
          name="name"
          placeholder="Product Name"
          value={formData.name}
          onChange={handleChange}
        />

        <textarea
          name="description"
          placeholder="Description"
          value={formData.description}
          onChange={handleChange}
        />

        <input
          name="price"
          type="number"
          placeholder="Price"
          value={formData.price}
          onChange={handleChange}
        />

        <input
          name="category"
          placeholder="Category"
          value={formData.category}
          onChange={handleChange}
        />

        <input
          name="quantity"
          type="number"
          placeholder="Quantity"
          value={formData.quantity}
          onChange={handleChange}
        />

        {/* Drag & Drop */}
        <div
          onDragEnter={handleDrag}
          onDragOver={handleDrag}
          onDragLeave={handleDrag}
          onDrop={handleDrop}
          style={{
            border: "2px dashed #999",
            padding: "20px",
            marginTop: "15px",
            textAlign: "center",
            background: dragActive ? "#f0f0f0" : "white",
          }}
        >
          <p>Drag & drop image here, choose file, or take photo</p>

          {/* File upload */}
          <div style={{ marginBottom: "10px" }}>
            <input
              type="file"
              accept="image/*"
              onChange={(e) => handleFile(e.target.files[0])}
            />
          </div>

          {/* Camera capture */}
          <div>
            <input
              type="file"
              accept="image/*"
              capture="environment"
              onChange={(e) => handleFile(e.target.files[0])}
            />
          </div>
        </div>

        {preview && (
          <div style={{ marginTop: "10px" }}>
            <img
              src={preview}
              alt="preview"
              style={{
                width: "100%",
                maxHeight: "250px",
                objectFit: "cover",
              }}
            />
          </div>
        )}

        <button type="submit" style={{ marginTop: "15px" }}>
          Create Product
        </button>
      </form>
    </div>
  );
}